export default __webpack_public_path__ + "static/media/medium.dc85d191.svg";